export default __webpack_public_path__ + "static/media/asistencia-contribuyente.24f83893.svg";